import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import messages from './messages';
import { statsService } from 'utils/api';

import session from 'containers/App/session';
import Button from 'components/forms/Button';

import { FormattedMessage, useIntl } from 'react-intl';
import { message, Popconfirm } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import DisplayTable from './DisplayTable';

const EventsManagement = ({ events, refreshEvents, showTickBox = false }) => {
    const intl = useIntl();
    const token = useSelector(session.selectors.selectUserToken);
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const [fetching, setFetching] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    let rowSelection = null;

    const deleteEvent = async (id) => {
        setFetching(true);
        try {
            await statsService({
                token,
                propertyId,
                resourceId: id,
            }).blacklistEvent();
            await refreshEvents();
            message.success(intl.formatMessage(messages.deleteSuccessMessage));
        } catch (err) {
            message.error(intl.formatMessage(messages.deleteErrorMessage));
        }
        setFetching(false);
    };

    const bulkBlacklistEvents = async () => {
        setFetching(true);
        try {
            await statsService({
                token,
                propertyId,
            }).bulkBlacklistEvents({
                eventIds: selectedRows,
            });
            await refreshEvents();
            setSelectedRows([]);
            message.success(intl.formatMessage(messages.deleteSuccessMessage));
        } catch (err) {
            message.error(intl.formatMessage(messages.deleteErrorMessage));
        }
        setFetching(false);
    };

    const onSelectRowChange = (newSelectedRowKeys) => {
        setSelectedRows(newSelectedRowKeys);
    };

    if (showTickBox) {
        rowSelection = {
            selectedRowKeys: selectedRows,
            onChange: onSelectRowChange,
        };
    }

    let content;
    if (fetching) {
        content = (
            <>
                <LoadingOutlined
                    style={{
                        marginRight: '8px',
                        verticalAlign: 'text-bottom',
                    }}
                />
                <FormattedMessage {...messages.loadingMessage} />
            </>
        );
    } else {
        content = (
            <>
                {showTickBox && (
                    <div>
                        <Popconfirm
                            title={<FormattedMessage {...messages.confirmDeletionText} />}
                            okText={<FormattedMessage {...messages.confirmOk} />}
                            cancelText={<FormattedMessage {...messages.confirmCancel} />}
                            onConfirm={() => bulkBlacklistEvents()}
                        >
                            <Button disabled={selectedRows.length < 1} type="danger">
                                <FormattedMessage {...messages.removeButton} />
                            </Button>
                        </Popconfirm>
                    </div>
                )}
                <div>
                    <DisplayTable
                        fetching={fetching}
                        data={events}
                        onClickDelete={deleteEvent}
                        rowSelection={rowSelection}
                    />
                </div>
            </>
        );
    }
    return <>{content}</>;
};

export default EventsManagement;
